// RH-PAIE-2D §7-8 — Select générique pour un dictionnaire code→libellé humain (statuts, sources,
// niveaux de confiance, domaines, unités, types, familles...). Commence toujours vide par défaut
// (aucune présélection) — l'appelant doit fournir explicitement une valeur pour en afficher une.
const GRIS_BORD = '#E0E0E0';

export default function SelectHumanise({ value, onChange, dictionnaire, placeholder = 'Sélectionner…', disabled = false, style }) {
  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={{ width: '100%', padding: '8px 12px', border: `1px solid ${GRIS_BORD}`, borderRadius: 6, fontSize: 13, background: disabled ? '#f5f5f5' : '#fff', ...style }}
    >
      <option value="">{placeholder}</option>
      {Object.entries(dictionnaire).map(([code, libelle]) => (
        <option key={code} value={code}>{libelle}</option>
      ))}
    </select>
  );
}
